import { Log } from "../utils";
import { BaseItem } from "./BaseItem";
export class ViewItem extends BaseItem {
    get view() {
        return (this.mManager);
    }
    /**
     * Returns the first BasketItem referenced by this ViewItem.
     * Use getBasketItems() to get all items.
     */
    getFirstBasketItem() {
        if (this.mItem.basketItemIds == null || this.mItem.basketItemIds.length === 0)
            return (null);
        return (this.mManager.basket.getItemById(this.mItem.basketItemIds[0]));
    }
    getBasketItems() {
        const tItems = new Array();
        if (this.mItem.basketItemIds != null) {
            for (const tId of this.mItem.basketItemIds) {
                const tItem = this.mManager.basket.getItemById(tId);
                if (tItem != null)
                    tItems.push(tItem);
                else
                    Log.warn("Unknown basket item: " + tId);
            }
        }
        return (tItems);
    }
    /**
     * Searches for the set article item.
     */
    findSetArticle() {
        const tBasketItem = this.getFirstBasketItem();
        if (tBasketItem == null)
            return (null);
        const tSetArticle = tBasketItem.getSetArticle();
        if (tSetArticle == null)
            return (null);
        const tViewItem = this.mManager.getItemByBasketId(tSetArticle.id);
        if (tViewItem != null && tViewItem.item.itemType === "SetArticle")
            return tViewItem;
        else
            return (null);
    }
    //// protected /////////////////////////////////////////////////////////////////////////////////
    get asType() {
        return (this);
    }
    registerItem() {
        this.mManager._registerItem(this);
    }
}
